import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'ChangePassword',
  components: {
    EmailComp: require('../../components/email.vue').default,
    NewPasswordComp: require('../../components/newPassword.vue').default,
  },
  data: function () {
    return {
      email: { email: '', valid: false, },
      password: '',
      passwords: { password: '', password2: '', canContinue: false },
      completed: false,
      message: '',
      isInComm: false,
    }
  },
  computed: {
    changeEnabled: function () {
      return this.email.valid && this.passwords.canContinue && !this.isInComm && !this.completed;
    },
  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
    changePassword() {
      let prof = this.$store.getters.getProfileDetails;

      if (!prof)
        return;
       
      if (prof.registrationType == 1 && (!this.email.valid || this.email.email != prof.email)) {
        //email registration
        this.$notify({ duration: 10000, group: 'app', text: this.$t('login.WrongEmail'), type: 'warn' });
        return;
      }
      else if (prof.registrationType == 2 && (!this.email.valid || !prof.mobileNo.includes(this.email.email))) {
        //phone registration
        this.$notify({ duration: 10000, group: 'app', text: this.$t('login.WrongPhone'), type: 'warn' });
        return;
      }     

      this.isInComm = true;
      axios.post('/account/ChangePassword', { CurrentPassword: this.password, NewPassword: this.passwords.password })
        .then(response => {
          this.isInComm = false;
          this.completed = true;
          if (response.data.data.status == 0) {
            this.message = 'Password changed successfully.';
            setTimeout(function () { this.redirectBack(); }.bind(this), 3000);
          }
          else {
            this.message = response.data.data.text;
          }
        })
        .catch(e => { this.message = e.message })
    },
  },
}
